import { useEffect, useState } from "react";
import { fetchRollouts, type RolloutSummary } from "@/api/agent-control";

export function RolloutStatusTab() {
  const [rollouts, setRollouts] = useState<RolloutSummary[]>([]);
  useEffect(() => { fetchRollouts().then(setRollouts).catch(console.error); }, []);

  return (
    <div className="space-y-4 p-4">
      <h3 className="text-lg font-semibold">Rollout Status</h3>
      {rollouts.length === 0 ? (
        <p className="text-sm text-gray-500">No rollouts yet.</p>
      ) : (
        <table className="w-full text-sm">
          <thead><tr className="border-b text-left">
            <th className="py-2 pr-4">ID</th>
            <th className="py-2 pr-4">Status</th>
            <th className="py-2 pr-4">Strategy</th>
            <th className="py-2 pr-4">Bucket %</th>
            <th className="py-2 pr-4">Created</th>
          </tr></thead>
          <tbody>{rollouts.map((r) => (
            <tr key={r.rollout_id} className="border-b">
              <td className="py-2 pr-4 font-mono text-xs">{r.rollout_id.slice(0, 8)}...</td>
              <td className="py-2 pr-4"><StatusBadge status={r.status} /></td>
              <td className="py-2 pr-4">{r.strategy}</td>
              <td className="py-2 pr-4">{r.bucket_pct}%</td>
              <td className="py-2 pr-4">{r.created_at ? new Date(r.created_at).toLocaleString() : "—"}</td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </div>
  );
}

function StatusBadge({ status }: { status: string }) {
  const colors: Record<string, string> = {
    planned: "bg-gray-100 text-gray-800",
    active: "bg-blue-100 text-blue-800",
    paused: "bg-yellow-100 text-yellow-800",
    aborted: "bg-red-100 text-red-800",
    completed: "bg-green-100 text-green-800",
  };
  return <span className={`px-2 py-0.5 rounded text-xs ${colors[status] || ""}`}>{status}</span>;
}
